module["exports"] = [
  "Polska"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/default_country.js
// module id = 970
// module chunks = 0